import { useEffect, useState } from "react";
import { useLocation, useParams, useNavigate } from "react-router-dom";
import { Post } from "components/Post/post";
import UserApi from "apis/UserApi";
import { SchoolHeader } from "components/ShoolHeader/schoolHeader";

export default function SharePage() {
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const location = useLocation();
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchPost = async () => {
      try {
        setLoading(true);
        // Get post data from location state or fetch from API
        const postData = location.state?.post;
        if (postData) {
          setPost(postData);
        } else if (id) {
          // If no state, fetch post by ID
          const response = await UserApi.getPostById(id);
          console.log('API Response:', response); // Debug log

          // Check if response has data
          if (response && response.data) {
            // Format the post data to match Post component requirements
            const formattedPost = {
              id: response.data.data.id,
              title: response.data.data.title || "",
              description: response.data.data.description || "",
              date: response.data.data.created_at || new Date().toISOString(),
              location: response.data.data.location || "",
              likes: response.data.data.likes || 0,
              media_url: response.data.data.media_url || [],
              base_URL: process.env.REACT_APP_API_BASE_URL || "",
              badge: response.data.data.feed_type || null
            };
            console.log('Formatted Post:', formattedPost); // Debug log
            setPost(formattedPost);
          } else {
            throw new Error("Post data not found in response");
          }
        } else {
          throw new Error("No post ID provided");
        }
      } catch (err) {
        console.error("Error fetching post:", err);
        setError(err.message || "Failed to load post");
      } finally {
        setLoading(false);
      }
    };

    fetchPost();
  }, [id, location.state]);

  const handleBack = () => {
    navigate('/home'); // Go back to previous page
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">Error</h2>
          <p className="text-gray-600 mb-4">{error}</p>
          <button
            onClick={handleBack}
            className="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors"
          >
            Go Back
          </button>
        </div>
      </div>
    );
  }

  if (!post) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">Post Not Found</h2>
          <p className="text-gray-600 mb-4">The post you're looking for doesn't exist or has been removed.</p>
          <button
            onClick={handleBack}
            className="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors"
          >
            Go Back
          </button>
        </div>
      </div>
    );
  }

  return (
    <>
    <SchoolHeader />
    <div className="min-h-screen bg-gray-50 py-8 pt-24">
      <div className="max-w-4xl mx-auto px-4">
        <div className="bg-white rounded-lg shadow-md p-6 mb-6">
          <div className="flex items-center justify-between mb-4">
            <h1 className="text-2xl font-bold text-gray-900">Shared Post</h1>
            <button
              onClick={handleBack}
              className="px-4 py-2 text-gray-600 hover:text-gray-900 transition-colors"
            >
              <i className="fas fa-arrow-left mr-2"></i>
              Back
            </button>
          </div>
          <p className="text-gray-600">
            This post was shared with you. You can view the full content below.
          </p>
        </div>
        <Post
          {...post}
          onLike={() => {}}
          onComment={() => {}}
          onShare={() => {}}
          onRSVP={() => {}}
        />
      </div>
    </div>
    </>
  );
}